// SPDX-FileCopyrightText: 2026 Mads Ringblom
//
// SPDX-License-Identifier: GPL-3.0-or-later

import type { LegendItem } from '../../bygning/lens';
import { cx } from '../cx';
import styles from './CanvasLegend.module.css';

/**
 * What the building's colours mean, over the model (the Ground places it):
 * a caption chip, then one light chip per row of `legendItems`. Lets the
 * pointer through to the model on desktop; on a phone it is one row that
 * scrolls sideways.
 */
export function CanvasLegend({ title, items }: { title: string; items: readonly LegendItem[] }) {
  if (items.length === 0) return null;
  return (
    <div className={styles.legend} role="group" aria-label={`Farver: ${title}`}>
      <span className={cx(styles.chip, styles.title)}>{title}</span>
      <ul className={styles.list}>
        {items.map((item) => (
          <li
            key={`${item.color ?? item.token ?? 'ghost'}:${item.label}`}
            className={cx(styles.chip, item.dim && styles.dim)}
            title={item.dim ? 'Uden for filteret' : undefined}
          >
            {!item.plain && (
              <i
                className={cx(styles.swatch, !item.token && !item.color && styles.ghost)}
                style={item.color ? { background: item.color } : item.token ? { background: `var(${item.token})` } : undefined}
                aria-hidden="true"
              />
            )}
            {item.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
